// @flow

import isAcceptedDeviation from "../tools/isAcceptedDeviation"

type Options = {
  onAcceptableDeviation?: (newPrice: number, diff: number) => void,
  onCheaper?: (newPrice: number, diff: number) => void,
  onMoreExpensive?: (newPrice: number, diff: number) => void,
  preferOriginalPriceWhenCheaper?: boolean,
}

function resolvePriceChange(
  originalPrice: number,
  newPrice: number,
  {
    onAcceptableDeviation,
    onCheaper,
    onMoreExpensive,
    preferOriginalPriceWhenCheaper = false,
  }: Options = {},
): number {
  const diff = newPrice - originalPrice
  if (diff === 0) {
    // Best scenario
    return newPrice
  }
  if (isAcceptedDeviation(newPrice, originalPrice)) {
    if (onAcceptableDeviation) {
      onAcceptableDeviation(originalPrice, diff)
    }
    return originalPrice
  }
  if (diff > 0) {
    if (onMoreExpensive) {
      onMoreExpensive(newPrice, diff)
    }

    return newPrice
  }
  if (diff < 0) {
    if (onCheaper) {
      onCheaper(originalPrice, diff)
    }

    return preferOriginalPriceWhenCheaper ? originalPrice : newPrice
  }

  return originalPrice
}

export default resolvePriceChange
